import React, { useState, useRef, useEffect, useContext } from 'react';
import { FaRobot, FaTimes, FaPaperPlane, FaTrash } from 'react-icons/fa';
import axios from 'axios';
import AuthContext from '../../context/AuthContext';
import './FloatingAIChat.css';

const FloatingAIChat = () => {
  const { user } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      role: 'assistant',
      content: 'Hello! I am your AI Medical Assistant. How can I help you today?'
    }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const userMessage = input.trim();
    setInput('');

    setMessages(prev => [...prev, { role: 'user', content: userMessage }]);
    setLoading(true);

    try {
      const response = await axios.post('/api/ai-assistant.php', {
        message: userMessage,
        history: messages.slice(-10)
      });

      setMessages(prev => [...prev, {
        role: 'assistant',
        content: response.data.response
      }]);
    } catch (err) {
      console.error('AI Error:', err);
      setMessages(prev => [...prev, {
        role: 'assistant',
        content: '❌ Sorry, I encountered an error. Please try again.'
      }]);
    } finally {
      setLoading(false);
    }
  };

  const clearChat = () => {
    setMessages([
      {
        role: 'assistant',
        content: 'Chat cleared. How can I help you?'
      }
    ]);
  };

  return (
    <>
      {/* Only show for logged-in users */}
      {!user && null}
      
      {user && (
        <>
          {/* Floating Button */}
          {!isOpen && (
            <button
              className="floating-ai-button"
              onClick={() => setIsOpen(true)}
              title="AI Medical Assistant"
            >
              <FaRobot size={28} />
            </button>
          )}

          {/* Chat Window */}
          {isOpen && (
        <div className="floating-ai-chat">
          {/* Header */}
          <div className="floating-ai-header">
            <div>
              <FaRobot className="me-2" />
              <strong>AI Medical Assistant</strong>
            </div>
            <div>
              <button
                className="floating-ai-icon-btn"
                onClick={clearChat}
                title="Clear Chat"
              >
                <FaTrash size={14} />
              </button>
              <button
                className="floating-ai-icon-btn"
                onClick={() => setIsOpen(false)}
                title="Close"
              >
                <FaTimes size={16} />
              </button>
            </div>
          </div>

          {/* Messages */}
          <div className="floating-ai-messages">
            {messages.map((message, index) => (
              <div
                key={index}
                className={`floating-ai-message ${message.role}`}
              >
                <div className="message-content">
                  {message.content}
                </div>
              </div>
            ))}
            
            {loading && (
              <div className="floating-ai-message assistant">
                <div className="message-content">
                  <div className="typing-indicator">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            )}
            
            <div ref={messagesEndRef} />
          </div>

          {/* Input */}
          <form onSubmit={handleSubmit} className="floating-ai-input">
            <input
              type="text"
              placeholder="Ask about medicines, diseases..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              disabled={loading}
            />
            <button type="submit" disabled={loading || !input.trim()}>
              <FaPaperPlane />
            </button>
          </form>
        </div>
      )}
        </>
      )}
    </>
  );
};

export default FloatingAIChat;
